import { PositionProps, Slide } from '@features/powerpoint';
import { CALCULATIONS } from '@features/glossary/subdomains/cpg';
import { contentSlideHeader } from '@features/lci-report/utils';
import { column } from '@features/lci-report/slides/appendix/calculations/components/column';
import { TITLE } from '@features/lci-report/slides/shared/dark-background-slide-master';
import { theme } from '@features/lci-report/domain/theme';
import { calculationEntry } from '@features/lci-report/slides/appendix/calculations/components/calculation-entry';

const entriesPerColumn = [6] as const;
const positionProps = [
  { h: 3.17, w: 3.99, x: 0.79, y: 1.91 },
  { h: 4.38, w: 6.04, x: 4.93, y: 1.95 },
] as const satisfies PositionProps[];

export const calculationsSlide = (): Slide => {
  const allCalculationItems = Object.values(CALCULATIONS).flatMap(section =>
    Object.values(section.items)
  );
  const columns = entriesPerColumn.map((entries, index) => {
    const start = entriesPerColumn
      .slice(0, index)
      .reduce((acc, cur) => acc + cur, 0);
    const end = start + entries;
    return allCalculationItems.slice(start, end);
  });

  return {
    slideMaster: TITLE,
    texts: [
      contentSlideHeader('Calculations', { color: theme.colors.white }),
      ...columns.map((columnItems, index) =>
        column(
          {
            label: '',
            items: {
              text: columnItems.flatMap(item => [
                ...calculationEntry({
                  label: item.label,
                  definition: item.calculation,
                }),
                {
                  text: '',
                  options: { breakLine: true },
                },
              ]),
            },
          },
          positionProps[index] ?? positionProps[0]
        )
      ),
    ],
  };
};
